export const CATEGORIES = {
  GUARANTEED_ISSUE: "guaranteed_issue",
  GUARANTEED_ISSUE_FOR_BUILD: "guaranteed_issue_for_build",
};
export type Category = (typeof CATEGORIES)[keyof typeof CATEGORIES];

export function extractCategories(str: string) {
  const categories: Category[] = [];
  if (!str) return categories;

  const strCategories = str.split(".");

  for (const [key, value] of Object.entries(CATEGORIES)) {
    if (strCategories.includes(value)) {
      categories.push(key);
    }
  }

  return categories;
}
